// rules.jsx
import React, { useEffect, useState } from 'react';
import './rules.css';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { registerPlayer } from '../../functions/registerPlayer';
import { getPlayer } from '../../functions/getPlayer';
import { selectAdminToken } from '../../admin/sessionSlice';
import { setBackButtonUrl } from '../uiSlice';
import IntroModal from '../introModal/introModal';

const NEXT_ROUTE = "/teamWaiting";

function UserRules() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status: themeStatus, data: themeData } = useSelector(
    (state) => state.theme
  );
  const { status, user, error } = useSelector((state) => state.auth);
  const [showIntroModal, setShowIntroModal] = useState(false);
  const [canProceedToNext, setCanProceedToNext] = useState(true);
  const [replayChecked, setReplayChecked] = useState(false);
  const adminToken = useSelector(selectAdminToken);

  console.log(themeData);

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    getPlayer({
      userId: user.userId,
      sessionId: user.sessionId,
      organizationId: user.organizationId,
    })
      .then((res) => {
        if (cancelled) return;
        if (res.status === 'completed') {
          navigate('/thankyou', { replace: true });
          return;
        }
        setReplayChecked(true);
      })
      .catch(() => {
        // No existing player row yet (e.g. brand new user) — safe to proceed.
        if (!cancelled) setReplayChecked(true);
      });
    return () => {
      cancelled = true;
    };
  }, [user, navigate]);

  useEffect(() => {
    if (!user || !adminToken) return;
    registerPlayer({
      userId: user.userId,
      playerName: user.name,
      token: adminToken,
    }).catch((err) => {
      console.error('Failed to register player:', err);
    });
  }, [user, adminToken]);

  useEffect(() => {
    dispatch(setBackButtonUrl("/login?&save=true"));
  }, [status, user]);

const handleIntroComplete = () => {
  setShowIntroModal(false);
  navigate(NEXT_ROUTE);
};


  const handleCloseIntroModal = () => {
    setShowIntroModal(false);
    // If user closes without completing, still allow access
    // (you can change this behavior if needed)
    setCanProceedToNext(true);
  };

  const handleNextClick = (e) => {
    e.preventDefault();

    // If an intro file is configured, show it first
    if (themeData?.intro && themeData?.introFile) {
      setShowIntroModal(true);
      setCanProceedToNext(false);
      return;
    }

    // Otherwise proceed to next page directly
    navigate(NEXT_ROUTE);
  };

  if (!themeData || !user || !replayChecked) {
  return (
      <div className='quiz-loader-container'>
       <div className="quiz-loader"></div>
      </div>
  );
}

  return (
    <>
      <div className="user-rules-container">
        <div className="user-rules-panel">
          <div className="user-rules-heading">Rules</div>
          <ul className="user-rules-list">
            {
              themeData?.rules.map((rules, index) => (
                <li key={index}>
                  <i
                    className="fa fa-arrow-right user-rule-icon"
                    aria-hidden="true"
                  />
                  {rules}
                </li>
              ))
            }
          </ul>
          <div style={{ textAlign: "center" }}>
            <button
              className="user-next-button"
              onClick={handleNextClick}
            >
              Next
            </button>
          </div>
        </div>
      </div>

      {/* Intro Modal */}
      <IntroModal
        isOpen={showIntroModal}
        onClose={handleCloseIntroModal}
        onComplete={handleIntroComplete}
        introFile={themeData?.introFile}
      />
    </>
  )
}

export default UserRules;